import { type ReactElement } from 'react';
import { DataTableNetworkDiscoveryContent } from './DataTableNetworkDomainsTab';

/**
 * Shadow AI → Network Discovery page (KIR-3496). Renders the counter widgets
 * (`NetworkTrafficDashboard`) followed by the DataTable-based domains table
 * with per-column Filter / Sort / Search. Table state is owned internally by
 * the DataTable.
 */
export function ShadowAiNetworkPage({
  organizationId,
}: {
  organizationId: string;
}): ReactElement {
  return <DataTableNetworkDiscoveryContent organizationId={organizationId} />;
}
